<template>
  <div id="main">
    <img v-if="mainInfo.show"
         v-bind:src="'/api/common/path/' + this.mainInfo.filePath + '?name='+ encodeURI(encodeURIComponent(this.mainInfo.fileName))"
         class="center"/>
    <div id="wrap">

    </div>
  </div>
</template>
<script>
  import Vue from 'vue'

  import MainInfoProxy from "../../../../proxies/MainInfoProxy";

  export default {
    components: {
    },
    created: function () {
      new MainInfoProxy()
        .find(this.mainInfo.infoType)
        .then((response) => {
          if (response.mainInfo !== undefined) {
            this.mainInfo = response.mainInfo;
          }
        })
    },
    methods: {

    },
    data() {
      return {
        mainInfo: {
          infoType: "mediaInfo",
          infoHtml: "",
          show: false
        },
      }
    },
  }
</script>
<style scoped>
  .center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 1280px;
  }
</style>
